import { useSelector } from "react-redux";
import { selectAppPersonalizations } from "../services/utils/appInfoSlice";
import styled, { css } from 'styled-components'


const Title = styled.h1`
  font-size: 1.5em;
  text-align: center;
  color: #BF4F74;
`;

const DefaultButton = styled.button`
  /* Adapt the colors based on primary prop */
  background: ${props => props.$bgColor};
  color: ${props => props.$color};
  font-size: 18px;
  font-family: font_${props => props.$level}_button,Quicksand;
  font-weight: 700;
  padding: 8px 32px;
  border: ${props => props.$borderSize}px solid;
  border-color: ${props => props.$borderColor};
  border-radius: ${props => props.$borderSize}px;
  max-width: 320px;
  display: block;
  width: 100%
`;




export default function Button({ type='button', color='primary', className='', size, children, disabled=false, customize=false, onClick = null }) {

    const personalizations = useSelector(selectAppPersonalizations);

    const colors = {
        primary: personalizations?.primary_button?.text?.color ? personalizations?.primary_button?.text?.color : '#FFFDFC',
        secondary: personalizations?.secondary_button?.text?.color ? personalizations?.secondary_button?.text?.color : '#436094'
    }

    const bgColors = {
        primary: personalizations?.primary_button?.background_color ? personalizations?.primary_button?.background_color : '#436094',
        secondary: personalizations?.secondary_button?.background_color ? personalizations?.secondary_button?.background_color : '#FFFDFC'
    }

    const borderColors = {
        primary: personalizations?.primary_button?.border?.color ? personalizations?.primary_button?.border?.color : '#436094',
        secondary: personalizations?.secondary_button?.border?.color ? personalizations?.secondary_button?.border?.color: '#436094'
    }

    const borderSize = {
        primary: personalizations?.primary_button?.border?.depth ? personalizations?.primary_button?.border?.depth : '0',
        secondary: personalizations?.secondary_button?.border?.depth ? personalizations?.secondary_button?.border?.depth: '0'
    }

    const borderRadius = {
        primary: personalizations?.primary_button?.corner_radius ? personalizations?.primary_button?.corner_radius : '16',
        secondary: personalizations?.secondary_button?.corner_radiush ? personalizations?.secondary_button?.corner_radius: '16'
    }

    if(!customize)
        return (
            <button type={type} disabled={disabled} className={className} onClick={onClick}>
                {children}
            </button>
        )
    else 
        return (
            <DefaultButton type={type} disabled={disabled} className={className} onClick={onClick} $color={colors[color]} $bgColor={bgColors[color]} $boderColor={borderColors[color]} $borderSize={borderSize[color]} $borderRadius={borderRadius[color]}>
                {children}
            </DefaultButton>
        )
}

